export default __webpack_public_path__ + "assets/models/34c0f9af2e5604d17838e9d5effca9db.glb";